// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__y_Psp","title":"Images90_title__2Gj4e","images":"Images90_images__1q-6h"};